// extracted by mini-css-extract-plugin
export default {"labelWrapper":"bMwv5iaF6WhnMogiDCnFcg==","releaseLabel":"fA9f7UggwTM5J2a30ev2TQ==","releaseIcon":"kavfn6oIjDhDiKY229Jz6Q=="};